import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" {...props}><path d="M443.213 121l-121-121H60v121H0v391h512V121h-68.787zM331 51.213L400.787 121H331V51.213zM90 30h211v121h121v30H269.493c-6.969-34.191-37.274-60-73.493-60H90V30zm392 452H30V151h166c24.813 0 45 20.187 45 45v15h241v271zm0-301h-30v-30h30v30z" /></svg>);